import { Component } from 'react';

import { Trans } from '@lingui/react/macro';

import logger from '../../utils/logger';
import { GenericError } from '../GenericError/GenericError';

export class ErrorBoundary extends Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ hasError: true });
    logger.error(error.toString(), { stack: error.stack, ...info });
  }

  render() {
    if (this.state.hasError) {
      return (
        <GenericError
          errorText={<Trans>Sorry, something went wrong.</Trans>}
          callUs
        />
      );
    }
    return this.props.children;
  }
}
